export default function (props: any) {
    return (
        <svg width="9" height="8" viewBox="0 0 9 8" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M.043 0h8v8h-8z" />
                <path stroke="currentColor" d="M7.008 6.536v-6h-6M7.038.353.396 6.995" />
            </g>
        </svg>
    );
}

export const TopArrowIcon = (props: any) => (
    <svg width="16px" height="36px" viewBox="0 0 16 36" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
        <defs>
            <linearGradient x1="0%" y1="85.6607923%" x2="100%" y2="85.6607923%" id="linearGradient-hot">
                <stop stopColor="#FFBC86" offset="0%"></stop>
                <stop stopColor="#FF5C1D" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g id="终稿0323" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="制热" transform="translate(-139.000000, -122.000000)" fill="url(#linearGradient-hot)">
                <g id="编组" transform="translate(139.000000, 54.045694)">
                    <g id="编组-13备份" transform="translate(0.308633, 52.900703)">
                        <path
                            d="M9.29136705,15.3292679 L9.291,37.3752679 L15.219696,37.3679742 L7.62698948,50.4349736 L-9.41382856e-05,37.3875263 L6.091,37.3792679 L6.09136705,15.3292679 L9.29136705,15.3292679 Z"
                            id="形状结合备份-2"
                            transform="translate(7.609848, 32.882121) scale(1, -1) translate(-7.609848, -32.882121) "
                        ></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
